'use client';
import { Typography } from '@mui/material';
import { useLocale } from 'next-intl';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';

import Icon from '@/ui/components/Icon';
import Link from '@/ui/components/Link';
import { addLocalePath } from '@/utils/urlBuilder/utils';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const List = styled.ul`
  border-top: 1px ${props => props.theme.palette.gray.main} solid;
  display: flex;
  flex-flow: column;
  margin: 0;
  padding: 0;
`;

const Item = styled.li`
  align-items: center;
  border-bottom: 1px ${props => props.theme.palette.gray.main} solid;
  color: ${({ theme }) => theme.custom.colors.gray800};
  display: flex;
  gap: 20px;
  padding: 20px;

  svg {
    color: ${({ theme }) => theme.custom.colors.brand};
    max-width: 24.5px;
  }

  a {
    color: ${({ theme }) => theme.custom.colors.gray800};
    margin-top: 2px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const GuideItem = ({ title, slug }) => {
  const locale = useLocale();

  return (
    <Item>
      <Icon name="book" size="2xl" />
      <Link href={addLocalePath(locale, `guide/${slug}`)}>{title}</Link>
    </Item>
  );
};

export default function ListOfGuides({ guides }) {
  const t = useTranslations();
  return (
    <Wrapper>
      <Typography variant="h4" component="h2">
        {t('manual-menu-contents')}
      </Typography>
      <List>
        {guides.map(({ title, slug }) => (
          <GuideItem key={slug} title={title} slug={slug} />
        ))}
      </List>
    </Wrapper>
  );
}
